import { formatNumbers, LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'

const { palette } = LuneThemeNew

export const Bar = ({
    maxValue,
    value,
    color,
    alignRight,
    average,
    averageUnit,
}: {
    maxValue: number
    value: number
    color: string
    alignRight?: boolean
    average?: number
    averageUnit?: string
}) => {
    const percentage = (value * 100) / maxValue
    const averagePercentage = average ? (average * 100) / maxValue : 0

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: alignRight ? 'flex-end' : 'flex-start',
                position: 'relative',
                '&:hover': {
                    '.average-tooltip': {
                        opacity: 1,
                    },
                },
            }}
        >
            <Box
                sx={{
                    maxWidth: `${percentage <= 0 ? 1 : percentage}%`,
                    backgroundColor: color,
                    borderRadius: '8px',
                    height: '48px',
                    lineHeight: '48px',
                    animation: `fill .3s cubic-bezier(0, 0.21, 0.99, 0.79) forwards`,
                    display: 'flex',
                    justifyContent: alignRight ? 'flex-end' : 'flex-start',
                    alignItems: 'center',
                    pl: 1,
                    pr: 1,
                    whiteSpace: 'nowrap',

                    [`@keyframes fill`]: {
                        '0%': {
                            width: `0%`,
                        },
                        '100%': {
                            width: `100%`,
                        },
                    },
                }}
            >
                <Text variant={'button'}> {formatNumbers(Math.round(value))}</Text>
            </Box>
            {average && (
                <Box
                    sx={{
                        height: '52px',
                        width: '2px',
                        background: palette.Grey900,
                        position: 'absolute',
                        top: '-2px',
                        left: `${averagePercentage - 1}%`,
                    }}
                >
                    <Text
                        className={'average-tooltip'}
                        sx={{
                            opacity: '0',
                            p: 1,
                            position: 'absolute',
                            top: '-32px',
                            transform:
                                averagePercentage > 80
                                    ? 'translateX(-100%)'
                                    : averagePercentage < 10
                                      ? 'translateX(0%)'
                                      : 'translateX(-50%)',
                            margin: 'auto',
                            minWidth: 'max-content',
                            background: `${palette.Grey900}`,
                            borderRadius: '8px',
                            color: 'white',
                            fontWeight: '500',
                            transition: 'opacity  .3s  cubic-bezier(0.3, 0.8, 0.5, 1.4) ',

                            ...(averagePercentage < 10 && {
                                left: '-10px',
                            }),

                            '&:before': {
                                content: '""',
                                width: '8px',
                                height: '8px',
                                transform: 'rotate(45deg)',
                                position: 'absolute',
                                background: `${palette.Grey900}`,
                                bottom: '-2px',
                                left: '2px',
                                right: 0,
                                margin: 'auto',

                                ...(averagePercentage > 80 && {
                                    right: 0,
                                    left: 'auto',
                                    transform: 'rotate(0deg)',
                                    bottom: '0px',
                                }),

                                ...(averagePercentage < 10 && {
                                    left: '7px',
                                    right: 'auto',
                                }),
                            },
                        }}
                        variant={'caption'}
                    >
                        <Text
                            variant={'caption'}
                            sx={{ mb: '2px', display: 'block', fontWeight: 500 }}
                        >
                            Industry trade lane average
                        </Text>
                        {average} {averageUnit}
                    </Text>
                </Box>
            )}
        </Box>
    )
}
